import { Field } from 'formik'
import InputComponent from '../reusable/Form/InputComponent'

const SupportAgree = () => {
  return (
    <div className="support_agree">
      <Field
        checkbox
        label="Я надаю згоду на обробку моїх персональних даних"
        name="agree"
        component={InputComponent}
      />

      <a
        className="public_offer"
        href="/docs/Публічна оферта оператора АСОП ЦМ у м.Буча.docx.pdf"
        target="_blank"
        rel="noreferrer"
      >
        Ознайомитись із публічною офертою
      </a>
    </div>
  )
}

export default SupportAgree
